module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vonwGp/tc-custom/9781615951734.jpg?1731411156827",
      "alt": "This image is the cover for the book Seven For a Secret, John, the Lord Chamberlain Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Seven For a Secret, John, the Lord Chamberlain Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Lord Chamberlain John spends his days counseling Emperor Justinian and passes the small hours of night in conversation with the solemn-eyed little girl depicted in a mosaic on his study wall. He never expected to meet her in a public square or afterwards find her red-dyed corpse in a subterranean cistern. Had the mysterious woman truly been the model for the mosaic years before as she claimed? Why had she sought John out? Who wanted her dead—and why?")]), _c('p', [_vm._v("The answers seem to lie among the denizens of the smoky streets of the quarter of Constantinople known as the Copper Market, where artisans, beggars, prostitutes, pillar saints, and exiled aristocrats struggle to survive within sight of the Great Palace. In his investigations, John encounters a faded actress, a patriotic sausage maker, a sundial maker who fears the sun, a religious visionary, a man who lives in a treasure trove, and a beggar who owes his life to a cartload of melons. But before long he suspects he is attempting to unravel not just a murder but a plot against the empire....")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mary Reed, Eric Mayer\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Poisoned Pen Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0